import * as React from "react";
import * as $ from 'jquery';

import CommunicationData from './CommunicationData';
import ConfigurationData from './ConfigurationData';
import CommunicationNavigation from './CommunicationNavigation';
import ConfigurationNavigation from './ConfigurationNavigation';

import {IApplicationStoreState, applicationStore} from '../stores/ApplicationStore'
import {ActionCreator} from '../actions/ActionCreator'

export interface IMainPageState extends IApplicationStoreState {
    activeActionData?: IActionData,
    activeConfigurationData?: IConfigurationData,
    isNewConfiguration?: boolean
}

export default class MainPage extends React.Component<any, IMainPageState> {

    constructor() {
        super();

        this.state = Object.assign({}, applicationStore.getState(), {
            isNewConfiguration: false,
            activeActionData: null,
            activeConfigurationData: null
        });

        this.communicationNavigationClick = this.communicationNavigationClick.bind(this);
        this.configurationNavigationClick = this.configurationNavigationClick.bind(this);
        this.checkPriority = this.checkPriority.bind(this);
        this.changeConfigurationData = this.changeConfigurationData.bind(this);
        this.onChange = this.onChange.bind(this);
        this.newConfiguration = this.newConfiguration.bind(this);
        this.saveConfiguration = this.saveConfiguration.bind(this);
        this.deleteConfiguration = this.deleteConfiguration.bind(this);
    }

    checkPriority(data: IConfigurationData, priority: number) {
        return this.state.configurationData.filter(function(rec: IConfigurationData): boolean {
            if (rec.Guid != data.Guid && rec.Type === data.Type && rec.Priority == priority) {
                return true;
            }

            return false;
        }, this).length == 0;
    }

    communicationNavigationClick(data: IActionData) {
        var newState = $.extend({}, this.state, { activeActionData: data });
        this.setState(newState);
    }

    configurationNavigationClick(data: IConfigurationData) {
        var newState = $.extend({}, this.state, {
            activeConfigurationData: data,
            isNewConfiguration: false
        });
        this.setState(newState);
    }

    newConfiguration() {
        var newState = $.extend({}, this.state, {
            isNewConfiguration: true,
            activeConfigurationData: {
                Guid: '',
                Type: 'Activate',
                Priority: null,
                Name: null,
                MatchingJson: "{}",
                Result: "{}"
            } 
        });
        this.setState(newState);
    }

    changeConfigurationData(data: IConfigurationData) {
        var newConfigurationData = $.extend({}, this.state.activeConfigurationData, data);
        var newState = $.extend(this.state, {activeConfigurationData: newConfigurationData});
        this.setState(newState);
    }

    componentDidMount() {
        applicationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        applicationStore.removeChangeListener(this.onChange);
    }

    onChange() {
        var newState = $.extend({}, applicationStore.getState());
        newState.isNewConfiguration = this.state.isNewConfiguration;
        if (this.state.activeConfigurationData) {
            var foundConfigurationData = newState.configurationData.find(function(d: IConfigurationData) {
                if (d.Guid === this.state.activeConfigurationData.Guid) {
                    return d;
                }
            }, this);
            if (foundConfigurationData || newState.isNewConfiguration) {
                newState.activeConfigurationData = this.state.activeConfigurationData;
            } else {
                newState.activeConfigurationData = null;
            }
        }
        if (this.state.activeActionData) {
            var foundActionData = newState.communicationData.find(function(d: IActionData) {
                if (d.Guid === this.state.activeActionData.Guid) {
                    return d;
                }
            }, this);
            if (foundActionData) {
                newState.activeActionData = this.state.activeActionData;
            } else {
                newState.activeActionData = null;
            }
        }
        this.setState(newState);
    }
    
    saveConfiguration() {
        ActionCreator.saveConfiguration(this.state.merchantId, this.state.terminalId, this.state.activeConfigurationData);
        var newState = $.extend(this.state, {isNewConfiguration: false});
        this.setState(newState);
    }
    
    deleteConfiguration() {
        ActionCreator.deleteConfiguration(this.state.merchantId, this.state.terminalId, this.state.activeConfigurationData);
        var newState = $.extend(this.state, {activeConfigurationData: null});
        this.setState(newState);
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-8 col-md-9 col-sm-push-4 col-md-push-3">
                    {
                    this.props.isCommunicationActive
                        ? <CommunicationData activeData={this.state.activeActionData} />
                        : <ConfigurationData checkPriority={this.checkPriority}
                            activeData={this.state.activeConfigurationData}
                            isNewConfiguration={this.state.isNewConfiguration}
                            changeState={this.changeConfigurationData}
                            newConfigurationClick={this.newConfiguration}
                            isSelected={this.state.isSelected}
                            saveConfiguration={this.saveConfiguration}
                            deleteConfiguration={this.deleteConfiguration} />
                    }
                    </div>
                <div className="col-sm-4 col-md-3 col-sm-pull-8 col-md-pull-9 sidebar-pf sidebar-pf-left" style={{ minHeight: "900px" }}>
                    {
                    this.props.isCommunicationActive
                        ? <CommunicationNavigation activeData={this.state.activeActionData}
                            onItemClick={this.communicationNavigationClick} />
                        : <ConfigurationNavigation activeData={this.state.activeConfigurationData}
                            onItemClick={this.configurationNavigationClick} />
                    }
                    </div>
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/MainPage.tsx